































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import 'vue2-datepicker/index.css'
import Icon from '@/components/Icon.vue'
import { Debounce } from 'vue-debounce-decorator'
import moment from 'moment'

const DateRangePicker = require('vue2-datepicker').default
@Component({
  props: {
    type: {
      type: String,
      default: 'date'
    },
    value: {
      type: [String, Date]
    },
    validation: {
      type: String
    },
    trimIdentical: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Icon,
    DateRangePicker
  }
})

export default class DatepickerLabel extends Vue {
  date: string = '';
  isOpend: boolean = false;
  handleOpen () {
    this.isOpend = true
  }

  handleClose () {
    this.isOpend = false
  }

  @Debounce(100)
  emitInput (value: any) {
    this.$emit('input', value)
    this.close()
  }

  @Watch('value', { deep: true })
  initDate () {
    this.date = moment(this.$props.value).format(this.getFormat())
  }

  getFormat () {
    switch (this.$props.type) {
      case 'datetime':
        return 'MM/DD/YYYY HH:mm'
      default:
        return 'MM/DD/YYYY'
    }
  } 

  mounted () {
    this.initDate()
  }

  close () {
    // @ts-ignore
    this.$refs['dateRangePicker'].closePopup()
  }
}

